import { isCancel as u, AxiosError as R } from "axios";
import { AccessDenied as E } from "./index4.mjs";
import { BadRequest as g, BadRequestWithViolations as l } from "./index5.mjs";
import { ConflictError as k } from "./index6.mjs";
import { FailedDependency as T } from "./index9.mjs";
import { InternalError as y } from "./index10.mjs";
import { invalidTokenErrorMessages as q } from "./index11.mjs";
import { LockedError as F } from "./index12.mjs";
import { MaintenanceError as N } from "./index13.mjs";
import { NetworkError as A } from "./index14.mjs";
import { NotFound as w } from "./index15.mjs";
import { PayloadTooLarge as M } from "./index16.mjs";
import { UnauthorizedResponse as U } from "./index17.mjs";
import { UnprocessableContentError as W } from "./index18.mjs";
const V = (n, i) => {
  let r = !1, o = [];
  const f = () => n.post("/api/user/token/regenerate"), m = (t) => {
    o.push(t);
  }, h = () => {
    o.forEach((t) => t()), o = [];
  }, p = async (t) => {
    const e = t.config;
    if (!r) {
      r = !0;
      try {
        return await f(), r = !1, h(), await n(e);
      } catch (a) {
        throw r = !1, o = [], a;
      }
    }
    return new Promise((a) => {
      m(() => {
        a(n(e));
      });
    });
  };
  return async (t) => {
    var c, d;
    if (u(t))
      throw t;
    if (t = t, t.code === R.ERR_NETWORK)
      throw new A();
    const e = t.response;
    if (!e)
      throw t;
    switch (e.status) {
      case 400:
        throw "errors" in e.data ? new g(e.data) : new l(e.data);
      case 401:
        if (q.includes(e.data.message))
          return await p(t);
        {
          const s = e.data.redirect || e.data.location;
          if (s)
            throw new U(s);
          i == null || i.error("Unauthorized response", e.data);
        }
        break;
      case 403: {
        const s = ((c = e.data) == null ? void 0 : c.redirect) || ((d = e.data) == null ? void 0 : d.location);
        throw new E(s);
      }
      case 404:
        throw new w(w.isNotFoundResponse(e.data) ? e.data : void 0);
      case 409:
        throw new k(e.data);
      case 413:
        throw new M();
      case 422:
        throw new W(e.data);
      case 423:
        throw new F();
      case 424:
        throw new T(e.data.title);
      case 503:
        throw new N();
      case 500:
      case 502:
        throw new y();
    }
    throw t;
  };
};
export {
  V as getErrorMapper
};
